import * as React from "react";
import { CommonInputProps, TextInput } from "react-admin";
import Box from "@mui/material/Box";
import { InputLabel } from "@mui/material";

export interface MyTextInputProps extends CommonInputProps {}

export function MyTextInput(props: MyTextInputProps) {
  const { label, ...other } = props;

  return (
    <Box p={"8px 0"}>
      <InputLabel>{label}</InputLabel>
      <TextInput label={""} {...other} />
    </Box>
  );
}
